module.exports = __webpack_public_path__ + "img/warp_feeder.30c0bc17.svg";